import Link from 'next/link';
import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  border-radius: 32px;
  overflow: hidden;
  z-index: 1;
  padding: 2px;
  background: ${({ theme }) => theme.backgroundLighter};
  border: 1px solid ${({ theme }) => theme.keyline};
`;

export const Button = styled(Link)<{ $active?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 54px;
  text-align: center;
  border-radius: 32px;
  font-size: 16px;
  color: ${({ theme }) => theme.textDark};
  padding: 0 25px;

  ${({ $active, theme }) =>
    $active &&
    css`
      font-weight: bold;
      background-color: ${theme.white};
      border: 1px solid ${theme.keyline};
    `}
`;
